document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("doskiva-newsletter-form");
  if (!form) return;

  const btn = form.querySelector('button[type="button"]');
  const formContent = form.querySelector(".newsletter-form-content");
  const successBlock = form.querySelector(".newsletter-success");
  const successEmail = successBlock?.querySelector(".success-email");
  const honeypot = form.querySelector('input[name="website"]');
  const smsConsent = form.querySelector('input[name="sms_consent"]');
  const formAppeared = Date.now();
  let submitted = false;

  btn.addEventListener("click", async function () {
    console.log("button clicked");
    if (submitted) return;

    clearFieldErrors();

    const fullName = form.querySelector('input[name="full_name"]').value.trim();
    const email = form.querySelector('input[name="email"]').value.trim();
    const phone = form.querySelector('input[name="phone"]').value.trim();

    // honeypot bot prevention
    if (honeypot?.value) return;

    // validate all fields, collect all errors
    const nameParts = fullName.trim().split(/\s+/);
    const firstName = nameParts[0] || "";
    const lastName = nameParts.length > 1 ? nameParts.slice(1).join(" ") : "";

    const errors = [];

    if (!fullName || fullName.length < 2) {
      markFieldError("full_name");
      errors.push("Please enter your full name.");
    } else if (/\d/.test(firstName) || (lastName && /\d/.test(lastName))) {
      markFieldError("full_name");
      errors.push("Please enter a valid name without numbers.");
    }

    if (!email) {
      markFieldError("email");
      errors.push("Please enter your email address.");
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      if (!emailRegex.test(email)) {
        markFieldError("email");
        errors.push("Please enter a valid email address.");
      }
    }

    if (smsConsent?.checked) {
      if (!phone) {
        markFieldError("phone");
        errors.push("Please enter your phone number to subscribe via SMS.");
      } else {
        const digits = phone.replace(/\D/g, "");
        if (digits.length < 7 || digits.length > 15) {
          markFieldError("phone");
          errors.push("Please enter a valid phone number (e.g. +1 234 567 8900).");
        }
      }
    }

    if (errors.length > 0) {
      showMessage(form, errors.join(" "), false);
      return;
    }

    // build Klaviyo profile
    const profileAttributes = {
      email: email,
      first_name: firstName,
      last_name: lastName,
    };

    if (smsConsent?.checked) {
      const digits = phone.replace(/\D/g, "");
      profileAttributes.phone_number =
        digits.length === 10 ? `+1${digits}` : `+${digits}`;
    }

    const payload = {
      data: {
        type: "subscription",
        attributes: {
          custom_source: "Doskiva Circle Newsletter Form",
          profile: {
            data: {
              type: "profile",
              attributes: profileAttributes,
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: "Wa73z5",
            },
          },
        },
      },
    };

    // time gate — humans rarely fill forms in under 3s
    if (Date.now() - formAppeared < 3000) return;

    btn.disabled = true;
    btn.textContent = "Joining...";

    // POST to Klaviyo
    try {
      const response = await fetch(
        "https://a.klaviyo.com/client/subscriptions/?company_id=SWvyzn",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            revision: "2024-10-15",
          },
          body: JSON.stringify(payload),
        },
      );

      if (response.status === 202) {
        submitted = true;
        form.reset();
        clearFieldErrors();
        form.querySelector(".klaviyo-form-message")?.remove();
        if (formContent) formContent.style.display = "none";
        if (successBlock) {
          if (successEmail) successEmail.textContent = email;
          successBlock.style.display = "";
        }
      } else {
        const err = await response.json().catch(() => ({}));
        console.error("Klaviyo error:", err);
        showMessage(form, "Something went wrong. Please try again.", false);
      }
    } catch (e) {
      console.error("Network error:", e);
      showMessage(form, "Something went wrong. Please try again.", false);
    } finally {
      btn.disabled = false;
      btn.textContent = "Join The Doskiva Circle";
    }
  });

  function clearFieldErrors() {
    form.querySelectorAll(".form-input-field.has-error")
      .forEach(el => el.classList.remove("has-error"));
  }

  function markFieldError(inputName) {
    const field = form.querySelector(`input[name="${inputName}"]`)
      ?.closest(".form-input-field");
    if (field) field.classList.add("has-error");
  }

  function showMessage(form, message, success) {
    let msg = form.querySelector(".klaviyo-form-message");
    if (!msg) {
      msg = document.createElement("p");
      msg.className = "klaviyo-form-message";
      form.appendChild(msg);
    }
    msg.textContent = message;
    msg.className = "klaviyo-form-message" + (success ? " success" : " error");
  }
});
